import { createFileRoute } from "@tanstack/react-router";
import { ThermalMap } from "../features/topo/ThermalMap";

export const Route = createFileRoute("/w/$ws/map")({ component: ThermalMap });
